<template>
  <div>
    <!-- <h1>Uh-Oh!</h1>
    <h3>
      It looks like you're experiencing some network issues, please click the
      back button and try again.
    </h3>
    <router-link :to="{ name: 'course-list' }"
      >Or go back to the home page</router-link
    > -->
    <no-data />
  </div>
</template>
<script>
import NoData from '@/components/NoData.vue'
export default {
  components: {
    NoData
  }
}
</script>
